module.exports = __webpack_public_path__ + "img/stock5.4e22377a.png";